import React, { lazy } from 'react';
import { motion } from 'framer-motion';
export const VisualBreak3 = () => {
  return;
};